<template>
  <div>
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="Certification" :MediaListRef="MediaListRef">
        <template v-slot:PageBody>
          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_Certification')">
              <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_CompanyInfo_Certification_Blue_p')">
                </div>
              </template>
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t("lbl_EMPBE_CompanyInfo_Certification_enterprise") }}<br/>
                    <span class="nameEng_P">{{ $t("lbl_EMPBE_CompanyInfo_Certification_enterprise_Desc") }}</span>
                  </div>
                </div>
                <div class="col-12 Innovativemain">
                  <div class="InnovativeSwitches">
                    <switchIput  class="mt-2" ControlId="IshowLevel" v-model="IshowLevel">
                    </switchIput>
                  </div>
                  <div class="InnovativeSelect" v-if="IshowLevel">
                    <div class="row">
                      <div class="col-12">
                        <selection ControlId="sruiLevel"
                          :title="$t('lbl_EMPBE_CompanyInfo_Certification_SRSNlevel_PlaceOther')" label="Name"
                          name="sruiLevel" v-model="form.srui.sruiLevel" :options="SelectOptions.SRUILevelOptions"
                          :mandatory="$t('lbl_EMPBE_CompanyInfo_Certification_SRSNlevel_PlaceOther') + $t('lbl_IsRequire')"
                          :multiple="false" :preselect-first="true">
                        </selection>
                      </div>
                      <div class="MoreDivInLine_16 col-12">
                        <div class="MoreDivInLine_Row">
                          <selection ContolId="prov"
                            :title="$t('lbl_EMPBE_CompanyInfo_Certification_ProvCity_PlaceOther')"
                            :mandatory="$t('lbl_EMPBE_CompanyInfo_Certification_ProvCity_PlaceOther') + $t('lbl_IsRequire')"
                            v-model="form.srui.prov" label="text" :options="SelectOptions.ProvOptions">
                          </selection>
                        </div>
                        <div class="MoreDivInLine_Row">
                          <datePicker ControlId="effectiveFrom" input-class="datepicker-here form-control digits"
                            id="effectiveFrom" class="w-100" :minimumView="'year'" v-model="form.srui.effectiveFrom"
                            :maximumView="'year'" :format="'yyyy'"
                            :title="$t('lbl_EMPBE_CompanyInfo_Certification_StartDate_PlaceOther')"
                            :mandatory="$t('lbl_EMPBE_CompanyInfo_Certification_StartDate_PlaceOther') + $t('lbl_IsRequire')">
                          </datePicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="APlusABooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    <!-- {{ $t("lbl_EMPBE_CompanyInfo_Certification_CompanyManagement", { entitlement: 10 }) }} -->
                    <TipsAndPrivewDilog :id="'EMPBE_Comp_Banner_HeadquarterPhoto_Info'"
                      :Title="$t('lbl_EMPBE_CompanyInfo_Certification_CompanyManagement_Tips')">
                      <template v-slot:Text>
                        {{ $t("lbl_EMPBE_CompanyInfo_Certification_CompanyManagement", { entitlement: GetCertificationListNums }) }}
                      </template>
                    </TipsAndPrivewDilog>
                  </div>
                </div>
                <div class="col-12">
                  <CertificationList
                    :nums="GetCertificationListNums"
                    v-model="form.companyManagementCerts"
                    :CertificationTypeOptions="SelectOptions.CertificationTypeOptions"
                    :supplierId="supplierId"
                    ref="CertificationList"
                    @removeCertImage="removeCertImage"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </PageValidate>
      <CompanyCert id="CompanyCert_ebooth"></CompanyCert>
    </b-overlay>
  </div>
</template>

<script>
import { CompanyInfoService } from "../../_services";
import { LogService } from "../../_services/log.Service";
import CompanyCert from "./Popup/CompanyCert.vue";
import CertificationList from "./Popup/CertificationList.vue";
import BasicPageTop from "./Popup/BasicPageTop.vue"

export default {
  inject: {
    permissionData: { default: null },
    companyApprovalHost: { default: null },
  },
  props: ["supplierId", "SelectOptions", "submitType"],
  components: {
    CompanyCert, CertificationList, BasicPageTop,
  },
  data() {
    return {
      //Dirty
      loading: false,
      IsCreated:false,
      dirty: false,
      IshowLevel: false,
      form: {
        srui: {
          rid: undefined,
          empCompanyId: this.supplierId,
          sruiLevel: "-1",
          oldsruiLevel:"-1",
          prov: "",
          effectiveFrom: undefined
        },
        companyManagementCerts: [],
        validationErrorLog: ""
      },
      MediaListRef: [],
      removeCertCommands: [],
    };
  },
  computed: {
    useFormalTables() {
      const host = this.companyApprovalHost;
      return !!(host && host.fromAdmin && host.isApprovalMode);
    },
    GetCertificationListNums() {
      if (this.permissionData) {
        switch (this.permissionData["Type"]) {
          case "A+":
            return 50;
          case "A":
            return 10;
        }
      }
      return 1;
    },
    APlusABooth() {
      if (this.permissionData) {
        return ["A+","A"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    user() {
      return this.$store.state.authentication.user;
    },

  },
  watch: {
    form: {
      handler() {
        if(!this.IsCreated)
        {
          this.dirty = true;
          this.$store.state.dirty = this.dirty;
        }
        this.IshowLevel = this.form.srui.sruiLevel == "-1" ? false : true;
      },
      deep: true,
    },
    IshowLevel()
    {
      this.form.srui.sruiLevel = this.IshowLevel ? (this.form.srui.oldsruiLevel != "-1" ? this.form.srui.oldsruiLevel : "")  :"-1"
    },
    "form.companyManagementCerts": {
      handler(newVal) {
        const newRef = [];
        for (let i = 0; i < newVal.length; i++) {
          newRef.push(`CertificationList.certMediaUploader_${i}`);
        }

        this.MediaListRef = [...newRef];
      },
      deep: true,
    },
  },
  mounted() {
    this.InitData();
  },
  methods: {
    resetFilePendingUpdate() {
      this.form.companyManagementCerts = this.form.companyManagementCerts.map(c => {
        return {
          ...c,
          isPendingInsert: false,
          pendingFiles: [],
          updateFileCommands: [],
        }
      });

      this.removeCertCommands = [];
    },

    InitData() {
      this.GetData();
      this.resetFormVerify();
      setTimeout(() => {
        this.dirty = false;
        this.$store.state.dirty = this.dirty;
      }, 200);
    },
    GetData() {
      this.loading = true;
      this.IsCreated=true;
      this.resetFilePendingUpdate();
      CompanyInfoService.GetCompanyCert(this.supplierId, this.useFormalTables).then(res => {
        if (res.isSuccessful) {
          if (res.data.srui) {
            this.form.srui = {
              ...res.data.srui,
              oldsruiLevel: res.data.srui.sruiLevel
            };
          }

          this.form.companyManagementCerts = res.data.companyManagementCerts?.sort((a, b) => a.orderId - b.orderId).map((c, i) => {
            return {
              ...c,
              isPendingInsert: false,
              updateFileCommands: [],
              pendingFiles: [],
            };
          }) ?? [];
        }
        setTimeout(() => {
              this.IsCreated = false;
        }, 500);
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.Certification.reset();
    },

    // Get failed upload item text
    getFailedUploadItemText(key = "") {
      if (!key) return "";

      if (key.startsWith("Certification_")) return this.$t("lbl_EMPBE_CompanyInfo_Certification_CertImage");

      const mapping = {
      };

      return mapping[key] || "";
    },

    async fileUploadHandle(isSubmit) {
      const pendingFiles = [];

      this.form.companyManagementCerts.reduce((acc, curr) => {
          return curr.pendingFiles && curr.pendingFiles.length > 0 ? [...acc, ...curr.pendingFiles] : acc;
      }, []).forEach(f => {
        pendingFiles.push({
          ...f,
        })
      });

      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands: [],
        getFailedText: this.getFailedUploadItemText,
        uploadFinishCallback: (failedFilesFields) => this.$emit("uploadFinish", failedFilesFields)
      });
    },
    //整理結果提交save
    async AfterSaveResult(isSubmit) {
      this.form.validationErrorLog = "";

      const data = {
        ...this.form,
      };

      try {
        const uploadRes = await this.fileUploadHandle(isSubmit);

        data.companyManagementCerts = data.companyManagementCerts.map((d, i) => {
          const data = {
            rid: d.rid || null,
            empCompanyId: d.empCompanyId,
            certificationType: d.certificationType,
            certificationName: d.certificationName,
            fileID: d.fileID || null,
            fileName: d.fileName || null,
            orderId: i + 1
          };

          if (d.pendingFiles && d.pendingFiles.length > 0) {
            const pendingFileId = d.pendingFiles[0].id;
            const isUploaded = uploadRes?.successfulList?.find((u) => u.id === pendingFileId);
            
            if (isUploaded) {
              data.fileID = data.fileID || data.orderId * -1; // "UPDATE" | "INSERT"
              data.fileName = isUploaded.uploadedOssUrl;
            }
          } else if (d.updateFileCommands.length > 0 && d.updateFileCommands.find(c => c.command === 'DELETE')) {
            data.fileID = null;
            data.fileName = null;
          }

          return data;
        });
      } catch (error) {
        const errorMessage = error && error.message ? error.message : (typeof error === "string" ? error : "文件上传失败，请重试");
        data.validationErrorLog += (data.validationErrorLog ? "; " : "") + errorMessage;
      }
      data.srui.empCompanyId = this.supplierId;
      data.EmpCompanyId = this.supplierId;
      return data;
    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.supplierId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "Database",
        Action: action,
      }, errorLogObj);
    },

    //保存
    async Save() {
      var data = await this.AfterSaveResult(false);
      //写日志
      const query = {
        FormId: this.supplierId,
        Action: 'Before_Save',
        FormType: 'Company_Cert',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        CompanyInfoService.SaveCompanyCert(data).then(res => {
          if (res.isSuccessful) {
            this.InitData();
            resolve({
              isSuccessful: true,
              popupAlertMsg: this.$t("lbl_EMPBE_SubmitAlert_SaveSuccessMessage"),
            });
          } else {
            this.LogPageFormError({ res: res }, "Save_SaveCompanyCert");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Save_SaveCompanyCert");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message }),
            error: err,
          });
        })
      });

    },
    //提交
    async Submit() {
      var data = await this.AfterSaveResult(true);

      const query = {
        FormId: this.supplierId,
        Action: 'Before_Submit',
        FormType: 'Company_Cert',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        CompanyInfoService.SaveCompanyCert(data).then(result => {
          if (result.isSuccessful) {
            this.$refs.Certification
              .validate(true)
              .then(async (res) => {
                //写日志
                data.VaildError = res.fIldData;

                if (process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() == 'ai' || res.valid) {
                  this.InitData();
                  resolve({
                    isSuccessful: true,
                    isAllMandatoryFieldFilled: true,
                  });
                } else {
                  this.GetData();
                  resolve({
                    isSuccessful: true,
                    isAllMandatoryFieldFilled: false,
                  });
                }
              });
          } else {
            this.LogPageFormError({ result: result }, "Submit_SaveCompanyCert");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode", { code: result.statusCode, msg: result.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Submit_SaveCompanyCert");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasError", { msg: err.message }),
            error: err,
          });
        });
      });
    },

    removeCertImage(deleteCommand) {
      this.removeCertCommands.push(deleteCommand);
    },
  },
};
</script>
